import React, { Component } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import moment from 'moment';

import DetailHeader from '../../components/generics/DetailHeader';
import Spinner from '../../components/generics/Spinner';
import NoPermissionMessage from '../../components/generics/NoPermissionMessage'
import ListGeneralItems from '../../components/sessions/ListGeneralItems';
import EditSessionItems from '../../components/sessions/EditSessionItems';
import ProdAddProdClosedSession from '../../components/sessions/ProdAddProdClosedSession';

import { showErrors } from '../../utils/Helpers';
import Alert from '../../utils/Alert';

import {
  cleanSession,
  fetchSession,
  fetchSessionSuccess,
  fetchSessionFailure,
  fetchSessionDetail,
  fetchSessionDetailSuccess,
  fetchSessionDetailFailure,
  updateSession,
  updateSessionSuccess,
  updateSessionFailure,
  fetchSessionCanProduce,
  fetchSessionCanProduceSuccess,
  fetchSessionCanProduceFailure,
} from "../../store/sessions/actions";
import { withRouter } from "utils/WithRouter";

export class EditProductionContainer extends Component {
  // ---------------------------------------------------------------------------
  // Initialization
  // ---------------------------------------------------------------------------
  constructor(props) {
    super(props);
    this.state = {
      ingredients: [],
      leftovers: [],
      products: [],
      can_produce: [],
      ingredientsToRemove: [],
      leftoversToRemove: [],
      productsToAdd: [],
      productItemId: 0,
      productItem: undefined,
      pieces: '',
      times: 1,
      productAmount: '',
      isClear: true,
      productItemError: []
    }

    this.alertRef = React.createRef();
  }

  componentDidMount() {
    this.props.fetchSession(this.props.match.params.id);
    this.props.fetchSessionDetail(this.props.match.params.id);
    this.props.fetchSessionCanProduce(this.props.match.params.id);
  }

  componentDidUpdate(prevProps) {
    if(prevProps.sessionDetail.loading && !this.props.sessionDetail.loading){
      let ingredients = [];
      let leftovers = [];
      let products = [];
      this.props.sessionDetail.detail.results.forEach((detailItem) => {
        if (detailItem.is_ingredient) {
          ingredients.push(detailItem);
        } else if (detailItem.is_product) {
          products.push(detailItem);
        } else {
          leftovers.push(detailItem);
        }
      });
      this.setState({
        ingredients: ingredients,
        products: products,
        leftovers: leftovers
      });
    }
    if (prevProps.sessionCanProduce.loading && !this.props.sessionCanProduce.loading){
      this.setState({ can_produce: this.props.sessionCanProduce.products });
    }
  }

  // ---------------------------------------------------------------------------
  // Actions
  // ---------------------------------------------------------------------------
  onCancel = () => {
    this.props.history.push(`/session/${this.props.match.params.id}/`);
  };

  // ---------------------------------------------------------------------------
  // Edition
  // ---------------------------------------------------------------------------
  sessionIsEditable = () => {
    let editable = true;
    _.each(this.state.products, (prod) => {
      if (!prod.active) {
        editable = false;
        return
      }
    });
    return editable
  };

  handleItemRemoveOrRestore = (itemId, isIngredient) => {
    if (itemId) {
      let itemsToRemove = isIngredient ? this.state.ingredientsToRemove.slice() : this.state.leftoversToRemove.slice();
      let position = itemsToRemove.indexOf(itemId)
      if (position < 0) {
        itemsToRemove.push(itemId);
        isIngredient ? this.setState({ingredientsToRemove: itemsToRemove}) : this.setState({leftoversToRemove: itemsToRemove});
      } else {
        itemsToRemove.splice(position, 1)
        isIngredient ? this.setState({ingredientsToRemove: itemsToRemove}) : this.setState({leftoversToRemove: itemsToRemove});
      }
    }
  };

  handleIngredientRemoveOrRestore = (ingredientId) => {
    if (ingredientId) {
      let ingredientsToRemove = this.state.ingredientsToRemove.slice();
      let position = ingredientsToRemove.indexOf(ingredientId);
      if (position < 0) {
        ingredientsToRemove.push(ingredientId);
        this.setState({ingredientsToRemove})
      } else {
        ingredientsToRemove.splice(position, 1)
      }
    }
  };

  updateProductionSession = () => {
    if (this.state.ingredientsToRemove.length || this.state.leftoversToRemove.length || this.state.productsToAdd.length) {
      var data = { 'ingredients_to_activate': this.state.ingredientsToRemove,
                   'leftovers_to_delete': this.state.leftoversToRemove,
                   'products_to_add': this.state.productsToAdd}
      this.props.updateSession(this.props.session.id, data, this.props, this.alertRef);
    } else {
      this.props.history.push(`/session/${this.props.match.params.id}/`);
    }
  };

  // ---------------------------------------------------------------------------
  // Add new Products to closed session
  // ---------------------------------------------------------------------------
  arrayObjectIndexOf = (myArray, searchTerm, property) => {
    for(var i = 0, len = myArray.length; i < len; i++) {
      if (myArray[i][property] === searchTerm) return i;
    }
    return -1;
  };

  spliceError = (element, array) => {
    var errors = array.slice();
    var index = errors.indexOf(element);
    if(index !== -1){
      errors.splice(index, 1)
    }
    return errors
  };

  handleProductItemChange = (event) => {
    let item_index = this.arrayObjectIndexOf(this.state.can_produce, parseInt(event.target.value, 10), "id");
    if(item_index !== -1){
      let item = this.state.can_produce[item_index],
          pieces = item.master_packing_number || '',
          productAmount = item.default_item_weight || '',
          productItemError = this.spliceError('item',this.state.productItemError);

      if (productAmount) { productItemError = this.spliceError('amount', productItemError); }
      if (pieces) { productItemError = this.spliceError('pieces', productItemError); }

      this.setState({productItemId:item.id, productItem: item, productItemError, pieces, productAmount});
    }else{
      this.setState({productItemId:0, productItem: undefined, pieces: '', productAmount: ''});
    }
  };

  handleProductAmountChange = (event) => {
    let productItemError = this.spliceError('amount',this.state.productItemError);
    this.setState({productAmount:event.target.value, productItemError});
  };

  handleProductPiecesChange = (event) => {
    let productItemError = this.spliceError('pieces',this.state.productItemError);
    this.setState({ pieces: event.target.value, productItemError });
  };

  handleProductClear = () => {
    this.setState({
      productItemId: 0,
      productItem: undefined,
      isClear: true,
      pieces: '',
      productAmount: ''
    });
  };

  hasError = () => {
    return false;
  };

  handleAddProductItem = () => {
    //The user can only add a product when there is no error
    if(!this.hasError()){
      this.setState({ isSubmittingProductItems: true });
      if(
        this.state.productAmount !== ''
        && this.state.productAmount > 0
        && this.state.productItemId !== 0
        && this.state.pieces !== ''
        && this.state.pieces > 0
        && this.state.times !== ''
        && this.state.times > 0
      ){
        var products = this.state.products.slice();
        var productsToAdd = this.state.productsToAdd.slice();
        var productDetail = {
          id: 'NEW',
          weight: this.state.productAmount,
          item: this.state.productItem,
          number_items: this.state.pieces,
          active: true
        }
        for(let i=0 ; i < this.state.times ; i++) {
          products.push(Object.assign({}, productDetail));
          productsToAdd.push(Object.assign({}, productDetail));
        }
        this.setState({products, productsToAdd, isSubmittingProductItems: false});
      }else{
        let productItemError = this.state.productItemError;
        if(this.state.productAmount === '' || this.state.productAmount <= 0){
          productItemError = this.spliceError('amount',productItemError);
          productItemError.push('amount');
        }
        if(this.state.productItemId === 0){
          productItemError = this.spliceError('item',productItemError);
          productItemError.push('item');
        }
        if(this.state.pieces === '' || this.state.pieces <= 0){
          productItemError = this.spliceError('pieces',productItemError);
          productItemError.push('pieces');
        }
        this.alertRef.current.sendAlert('All field are required!')
        this.setState({
          isSubmittingProductItems: false,
          productItemError
        });
      }
    }else{
      this.alertRef.current.sendAlert('Please correct the error to continue.');
    }
  };

  handleOnTimesChange = (event) => {
    let times = event.target.value
    this.setState({times})
  };

  // ---------------------------------------------------------------------------
  // Render
  // ---------------------------------------------------------------------------
  render() {
    if(!this.props.session || this.props.session.loading ||
      !this.props.sessionDetail || this.props.sessionDetail.loading){
      return (
        <div>
          <Alert ref={this.alertRef}/>
          <Spinner />
        </div>

      );
    } else {
      if (this.sessionIsEditable()) {
        return (
          <div>
            <Alert ref={this.alertRef}/>
            <DetailHeader title="Production Session"
                          actionTitle="Update"
                          action ={this.updateProductionSession}
                          actionClass="btn btn-primary m-0"
                          actionIconClass="fa fa-check mr-05"

                          action2Available={true}
                          action2Title="Cancel"
                          action2 ={this.onCancel}
                          action2Class="btn btn-danger m-0 mr-05"
                          action2IconClass="fa fa-times mr-05"

                          col1Title="Session Number"
                          col1Desc={this.props.session.id}
                          col2Title="Date"
                          col2Desc={moment(this.props.session.date_created).format('LLL')}
                          col3Title="Station"
                          col3Desc={this.props.session.station.name} />

            <EditSessionItems
              items={this.state.ingredients}
              isIngredient={true}
              onItemRemoveOrRestore={this.handleItemRemoveOrRestore}
              deletedIngredients = {this.state.ingredientsToRemove}
            />
            <EditSessionItems
              items={this.state.leftovers}
              isLeftover={true}
              onItemRemoveOrRestore={this.handleItemRemoveOrRestore}
              deletedLeftovers = {this.state.leftoversToRemove}
            />
            <ListGeneralItems
              items={this.state.products}
            />
            <ProdAddProdClosedSession
              items={this.state.can_produce}
              onItemChange={this.handleProductItemChange}
              itemIndex={this.state.productItemIndex}
              item={this.state.productItem}
              amount={this.state.productAmount}
              onAmountChange={this.handleProductAmountChange}
              onAddItem={this.handleAddProductItem}
              isSubmittingItems={this.state.isSubmittingProductItems}
              errors={this.state.productItemError}
              hasPieces={true}
              onPiecesChange={this.handleProductPiecesChange}
              pieces={this.state.pieces}
              isClear={this.state.isClear}
              onClear={this.handleProductClear}
              preselectedProduct={this.state.preselectedProduct}
              onTimesChange={this.handleOnTimesChange}
              times={this.state.times}
            />
          </div>
        );
      } else {
        return (
          <NoPermissionMessage message={"You can not edit sessions with inactive products."}/>
        )
      }
    }
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    sessionDetail: state.sessions.productionSessionDetail,
    session: state.sessions.sessionDetail.session,
    sessionCanProduce: state.sessions.productionSessionCanProduce
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchSession: (sId) => {
      dispatch(fetchSession(sId)).payload.then((response) => {
        dispatch(fetchSessionSuccess(response.data))
      }, (error) => {
        dispatch(fetchSessionFailure(error));
      });
    },
    cleanSession: () => {
      dispatch(cleanSession());
    },
    fetchSessionDetail: (iId) => {
      dispatch(fetchSessionDetail(iId)).payload.then((response) => {
        dispatch(fetchSessionDetailSuccess(response.data))
      }, (error) => {
        dispatch(fetchSessionDetailFailure(error));
      });
    },
    fetchSessionCanProduce: (iId) => {
      dispatch(fetchSessionCanProduce(iId)).payload.then((response) => {
        dispatch(fetchSessionCanProduceSuccess(response.data))
      }, (error) => {
        dispatch(fetchSessionCanProduceFailure(error));
      });
    },
    updateSession: (sId, data, props, alertRef) => {
      dispatch(updateSession(sId, data)).payload.then((response) => {
        dispatch(fetchSessionDetail(sId)).payload.then((response) => {
          dispatch(fetchSessionDetailSuccess(response.data))
          dispatch(updateSessionSuccess(response.data))
          alertRef.current.sendAlert(
            "Production session successfully modified!",
            "success"
          );
          props.history.push(`/session/${props.match.params.id}/`)
        }, (error) => {
          dispatch(fetchSessionDetailFailure(error));
        });
      }, (error) => {
        dispatch(updateSessionFailure(error));
        showErrors(error, alertRef);
      });
    }
  };
};

export default connect( mapStateToProps, mapDispatchToProps)(withRouter(EditProductionContainer));
